import { Check } from 'lucide-react';
import { Reveal } from './Reveal';
import { IMG } from './HeroContrast';

const ROLES = [
  { id: 'chauffeur', q: 'Vous êtes chauffeur ?', pts: ['Moins de papier', 'Moins de retours au bureau', 'Fin de journée plus rapide'], tag: 'Retrouvez du temps pour ce qui compte.', img: 'vie_enfant' },
  { id: 'mecanicien', q: 'Vous êtes mécanicien ?', pts: ['Historique instantané', 'Moins de recherche', 'Plus de réparation'], tag: 'Votre expertise mérite mieux que des classeurs.', img: 'vie_peche' },
  { id: 'bureau', q: 'Vous êtes au bureau ?', pts: ['Moins de ressaisie', 'Moins de courriels', 'Moins de vérifications'], tag: 'Une information saisie une fois devrait servir partout.', img: 'vie_famille' },
  { id: 'repartiteur', q: 'Vous êtes répartiteur ?', pts: ["Moins d'appels", 'Plus de visibilité', 'Plus de contrôle'], tag: "Coordonnez les opérations. Pas la recherche d'information.", img: 'vie_amis' },
];

const Role = ({ r, flip }) => (
  <div className={`grid lg:grid-cols-12 gap-10 lg:gap-16 items-center`} data-testid={`role-${r.id}`}>
    <Reveal className={`lg:col-span-7 ${flip ? 'lg:order-2' : ''}`}>
      <div className="relative aspect-[16/10] rounded-2xl overflow-hidden group">
        <img src={IMG(r.img)} alt="" loading="lazy" className="w-full h-full object-cover transition-transform duration-[3000ms] ease-out group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0F19]/70 to-transparent" />
      </div>
    </Reveal>
    <Reveal delay={150} className="lg:col-span-5">
      <p className="font-heading text-3xl sm:text-4xl uppercase font-bold tracking-tight text-white mb-8">{r.q}</p>
      <ul className="space-y-3 mb-8">
        {r.pts.map(p => (
          <li key={p} className="flex items-center gap-3 text-lg text-slate-300">
            <Check size={18} className="text-amber-400 shrink-0" /> {p}
          </li>
        ))}
      </ul>
      <p className="text-xl text-amber-400 font-medium leading-snug border-l-2 border-amber-500/50 pl-5">{r.tag}</p>
    </Reveal>
  </div>
);

export const Roles = () => (
  <section className="bg-[#080B13] py-28 md:py-40" data-testid="roles-section">
    <div className="max-w-7xl mx-auto px-6 sm:px-10">
      <Reveal className="mb-20 md:mb-28">
        <p className="text-xs uppercase tracking-[0.3em] text-amber-500 font-semibold mb-3">Concrètement</p>
        <h2 className="font-heading text-4xl sm:text-5xl uppercase font-bold tracking-tight text-white">Comment cela se traduit-il ?</h2>
      </Reveal>
      <div className="space-y-28 md:space-y-36">
        {ROLES.map((r, i) => <Role key={r.id} r={r} flip={i % 2 === 1} />)}
      </div>
    </div>
  </section>
);
